/**
 * @param str The string to group
 * @param size The maximum group size
 *
 * @returns
 * An array of strings where each item has a maximum length of `size`.
 */
function getGrouped(str: string, size: number): string[] {
  if (size === 0) {
    throw new Error('groupSize must be bigger than 0');
  }

  const result = [];
  const { length } = str;

  for (
    let start = 0, end = start + size;
    start < length;
    start = end, end = start + size
  ) {
    result.push(str.slice(start, end));
  }

  return result;
}

/**
 * Represents SortCodes
 */
export class SortCode {
  /**
   * SortCode in electronic format (without separators)
   */
  private _value: string;

  constructor(sortCode: string) {
    this._value = sortCode;
  }

  public static parse(sortCodeStr: string): SortCode {
    // Remove separators
    return new SortCode(sortCodeStr.replace(/[-]/g, ''));
  }

  public get value() {
    return this._value;
  }

  /**
   * @param separator Separator between groups, defaults to '-'
   *
   * @returns
   * SortCode as string, grouped in groups of 2
   */
  public format(separator: string = '-'): string {
    return getGrouped(this.value, 2).join(separator);
  }
}
